import classnames from 'classnames';
import React from 'react';

import TRANSLATIONS from '../../../translations/translations@default.json';
import QuickSearchCarouselFacetContainer from './QuickSearchCarouselFacetContainer';

const buttonClasses =
	'bg-white border border-gray-30 border-solid flex h-10 items-center justify-center rounded-full w-10 z-10';
const buttonIconClasses = '-mt-px ico ico-lg text-cta-action';

const Arrow = ({ className, style, iconClasses, onClick }) => (
	<button
		type="button"
		className={classnames(buttonClasses, className)}
		style={{
			...style,
		}}
		onClick={() => {
			onClick();
		}}>
		<i className={classnames(buttonIconClasses, iconClasses)} />
	</button>
);

const NextArrow = (props) => (
	<Arrow
		{...{
			...props,
			style: { right: '-1rem', marginLeft: '0.275rem' },
			iconClasses: 'ico-chevron-right ml-1',
		}}
	/>
);

const PrevArrow = (props) => (
	<Arrow
		{...{ ...props, style: { left: '-1rem' }, iconClasses: 'ico-chevron-left' }}
	/>
);

const sideScroll = (element, direction, speed, distance, step) => {
	let scrollAmount = 0;
	let slideTimer = setInterval(function () {
		if (direction === 'left') {
			element.scrollLeft -= step;
		} else {
			element.scrollLeft += step;
		}
		scrollAmount += step;
		if (scrollAmount >= distance) {
			window.clearInterval(slideTimer);
		}
	}, speed);
};

const onArrowClick = (direction) => {
	var container = document.getElementById('quick-search-carousel');
	sideScroll(container, direction, 25, 200, 10);
};

const quickSearchCarouselFacets =
	TRANSLATIONS.quickSearchCarousel.quickSearchCarouselFacets;

const QuickSearchCarousel = () => {
	return (
		<div
			data-tag-section="quick search carousel"
			className="bg-white pt-3 rounded my-2 flex flex-col pl-2 md:pl-0 md:pt-4 md:my-4">
			<div className="flex flex-shrink-0 md:px-4">
				<span className="text-title-sm text-cta-main md:text-display md:text-cta-main md:block md:mb-2">
					{TRANSLATIONS.quickSearch.title}
				</span>
				<div className="ml-auto hidden md:flex">
					<PrevArrow onClick={() => onArrowClick('left')} />
					<NextArrow onClick={() => onArrowClick('right')} />
				</div>
			</div>
			<div
				id="quick-search-carousel"
				className="flex justify-between w-full overflow-x-scroll md:overflow-x-hidden pb-3 pt-2 md:pl-4">
				{quickSearchCarouselFacets.map((facet) => {
					return (
						<QuickSearchCarouselFacetContainer
							facetType={facet.facetType}
							facetValueArray={facet.facetValues}
							facetNameArray={facet.facetNames}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default QuickSearchCarousel;
